import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { IMG } from "@/lib/content";
import { useSeo } from "@/lib/seo";

export default function AdminLogin() {
  useSeo("Administration");
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };
  return (
    <div data-universe="common" className="pagne flex min-h-screen items-center justify-center bg-paper p-4">
      <form onSubmit={submit} className="card w-full max-w-md p-8" data-testid="admin-login-form">
        <div className="mb-6 flex items-center gap-2">
          <img src={IMG.logoOng} alt="" className="h-12 w-12" /><img src={IMG.logoAsso} alt="" className="h-12 w-12" />
        </div>
        <h1 className="font-display text-3xl font-bold uppercase text-ink">Back-office MA LEBA</h1>
        <p className="mb-6 text-sm text-neutral-600">Espace réservé aux administrateurs.</p>
        {error && <p className="mb-4 rounded-md bg-asso/10 p-3 text-sm text-asso" role="alert" data-testid="admin-login-error">{error}</p>}
        <label className="label" htmlFor="email">E-mail</label>
        <input id="email" type="email" required className="input mb-4" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
        <label className="label" htmlFor="password">Mot de passe</label>
        <input id="password" type="password" required className="input mb-6" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
        <button className="btn-u w-full" disabled={loading} data-testid="admin-login-submit">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Se connecter
        </button>
        <Link to="/admin/mot-de-passe-oublie" className="mt-4 block text-center text-sm text-u underline" data-testid="admin-forgot-password-link">
          Mot de passe oublié ?
        </Link>
      </form>
    </div>
  );
}
